import { render } from "@testing-library/react";
import { HeadersUtil } from "../../utils/headersUtil";
import axios from "axios";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import { ParamUtil, RequestParam } from "../../utils/paramUtil";
export class NotiService {
  private static _notiService: NotiService;

  public static getInstance(): NotiService {
    if (!NotiService._notiService) {
      NotiService._notiService = new NotiService();
    }
    return NotiService._notiService;
  }

  public getNotiByUserUid() {
    const url = process.env.REACT_APP_MAIN_URL + "/noti/getNotiByUid.do";
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getNotiById(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/noti/getNotiById.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getNotiByConnId(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/noti/getNotiByConnId.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public readNoti(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_MAIN_URL + "/noti/getNoti.do", params);
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public readAllNoti() {
    const url = process.env.REACT_APP_MAIN_URL + "/noti/readAllNoti.do";
    return axios.put(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }
}
